var map = {
	"./a11y.yaml": 468,
	"./addons.yaml": 469,
	"./applicationservices.yaml": 470,
	"./automation.yaml": 471,
	"./bugbot.yml": 472,
	"./bugzilla.yaml": 473,
	"./cargo.yaml": 474,
	"./clippy.yaml": 475,
	"./common-voice.yaml": 476,
	"./data.yaml": 477,
	"./fenix.yaml": 478,
	"./ff-build.yaml": 479,
	"./ff-infra.yaml": 480,
	"./firefox-devtools.yaml": 481,
	"./firefox-focus.yaml": 482,
	"./firefox-frontend.yaml": 483,
	"./firefox-ios.yml": 484,
	"./firefox-sync.yaml": 485,
	"./gfx.yaml": 486,
	"./internals.yaml": 487,
	"./machine-learning.yml": 488,
	"./mdn.yaml": 489,
	"./mozillavpn.yaml": 490,
	"./mozregression.yaml": 491,
	"./multi-account-containers.yaml": 492,
	"./pontoon.yaml": 493,
	"./releng.yaml": 494,
	"./rust-analyser.yaml": 495,
	"./rust-bindgen.yaml": 496,
	"./rust-cookbook.yaml": 497,
	"./rust.yaml": 498,
	"./rustfmt.yaml": 499,
	"./seamonkey.yaml": 500,
	"./searchfox.yaml": 501,
	"./servo.yaml": 502,
	"./spidermonkey.yaml": 503,
	"./sumo.yaml": 504,
	"./taskcluster.yaml": 505,
	"./thunderbird-android.yaml": 506,
	"./thunderbird.yaml": 507,
	"./treeherder.yaml": 508,
	"./webcompat.yaml": 509,
	"./webdevelopmenttools.yaml": 510,
	"./webextensions.yaml": 511,
	"./webplatform.yaml": 512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;